import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddPaymentComponent } from './base/add-payment/add-payment.component';
import { EditEnrollmentsComponent } from './base/edit-enrollments/edit-enrollments.component';
import { EditKidsComponent } from './base/edit-kids/edit-kids.component';
import { EditParentsComponent } from './base/edit-parents/edit-parents.component';
import { EditProfilesComponent } from './base/edit-profiles/edit-profiles.component';
import { EditProgramsComponent } from './base/edit-programs/edit-programs.component';
import { SendEmailComponent } from './base/send-email/send-email.component';
import { SettingsComponent } from './base/settings/settings.component';
import { UserProfileComponent } from './base/user-profile/user-profile.component';
import { AdminGuardService } from './services/admin-guard.service';
import { AuthGuardService } from './services/auth-guard.service';
import { ModeratorGuardService } from './services/moderator-guard.service';
import { GroupComponent } from './views/group/group.component';
import { TransportComponent } from './views/transport/transport.component';

const routes: Routes = [
    { path: 'enroll', loadChildren: () => import('./public/public.module').then(m => m.PublicModule) },
    { path: 'authentication', loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule) },
    { path: 'user-profile', component: UserProfileComponent, canActivate: [AuthGuardService] },
    { path: 'edit-profiles', component: EditProfilesComponent, canActivate: [AdminGuardService] },
    { path: 'edit-kids', component: EditKidsComponent, canActivate: [AdminGuardService] },
    { path: 'edit-parents', component: EditParentsComponent, canActivate: [AdminGuardService] },
    { path: 'edit-programs', component: EditProgramsComponent, canActivate: [AdminGuardService] },
    { path: 'edit-enrollments', component: EditEnrollmentsComponent, canActivate: [AdminGuardService] },
    { path: 'add-payment', component: AddPaymentComponent, canActivate: [AdminGuardService] },
    { path: 'settings', component: SettingsComponent, canActivate: [AdminGuardService] },
    { path: 'transport', component: TransportComponent, canActivate: [ModeratorGuardService] },
    { path: 'group', component: GroupComponent, canActivate: [ModeratorGuardService] },
    { path: 'send-email', component: SendEmailComponent, canActivate: [AdminGuardService] },
    { path: '', redirectTo: '/transport', pathMatch: 'full' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
